import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { categories } from './config';
import { CategoryKey } from './types';
import Categories from './Components/Categories';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@profile/src/utils/navigate';
import { TestableProvider } from '@wolffun/testable-id';

const Inventory = ({
  className
}) => {
  var _selectedTab$renderCa;

  const history = useHistory();
  const {
    category
  } = useParamsRoute();
  const selectedKey = category || CategoryKey.Heroes;
  const selectedTab = categories.find(e => e.key === selectedKey);
  return /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "inventory"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(Categories, {
    className: styles.category,
    onClickItem: e => history.push({
      search: `tab=${MenuItem.INVENTORY}&category=${e.key}`
    }),
    selectedKey: selectedKey,
    data: categories
  }), selectedTab === null || selectedTab === void 0 ? void 0 : (_selectedTab$renderCa = selectedTab.renderCategory) === null || _selectedTab$renderCa === void 0 ? void 0 : _selectedTab$renderCa.call(selectedTab)));
};

export default Inventory;